import { get } from 'helpers';

export const getClients = async ({ page = 0, by = 12, search = '' }) =>
  await get('/clients', { page: page.toString(), by, search });

export const getClientById = async id =>
  await get('/detailClient', { user_id: id });

export const getClientItems = async id => await get('/clients_items');
